import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import handleRelationshipOptions from '../../../common/FieldsList/utils/handleRelationshipOptions';
import handleRolesOptions from '../../../common/FieldsList/utils/handleRolesOptions';
import { PROFILE_FIELDS_TYPES } from '../../../../constants/formFields';
import { getFieldProps } from '../../../../utils/fields/getFieldProps';
import { DEPENDENT_ROLES, EMPTY_ROLE } from '../../../../constants';
import { FormErrorBlock } from '../../../common/FormErrorBlock';
import { DIALOG_TITLE } from '../../../../constants/strings';
import SelectCustom from '../../../SelectCustom';
import TextInput from '../../../TextInput';

import styles from '../../PatientRegistrationInfo/index.styl';

const {
  EMAIL,
  FIRST_NAME,
  LAST_NAME,
  PHONE_NUMBER,
  RELATION,
  ROLE,
  CARE_ROLE,
} = PROFILE_FIELDS_TYPES;

const EmergencyContactForm = ({
  email,
  onChange,
  lastName,
  relation,
  careRole,
  firstName,
  phoneNumber,
  formatMessage,
  validateErrors,
}) => {
  const makeProfileField = getFieldProps(formatMessage, onChange);

  return (
    <Fragment>
      {/*     F I R S T   N A M E     */}
      <TextInput
        {...makeProfileField(FIRST_NAME)}
        value={firstName}
        required={false}
      />
      <FormErrorBlock type={FIRST_NAME} errors={validateErrors} />
      {/*     L A S T   N A M E     */}
      <TextInput
        {...makeProfileField(LAST_NAME)}
        value={lastName}
        required={false}
      />
      <FormErrorBlock type={LAST_NAME} errors={validateErrors} />
      {/*     C A R E   R O L E     */}
      <SelectCustom
        {...makeProfileField(ROLE)}
        options={handleRolesOptions(
          formatMessage,
          {
            EMPTY_ROLE,
            ...DEPENDENT_ROLES,
          },
          false,
        )}
        value={careRole}
        needUpdateDefaultValue
        onChange={({ value }) => onChange({ [CARE_ROLE]: value })}
        defaultValue={careRole}
      />
      <FormErrorBlock type={CARE_ROLE} errors={validateErrors} />
      {/*     R E L A T I O N     */}
      <SelectCustom
        {...makeProfileField(RELATION)}
        options={handleRelationshipOptions(careRole, formatMessage)}
        value={relation}
        needUpdateDefaultValue
      />
      <FormErrorBlock type={CARE_ROLE} errors={validateErrors} />
      {/*     E M A I L     */}
      <TextInput {...makeProfileField(EMAIL)} value={email} />
      <FormErrorBlock type={EMAIL} errors={validateErrors} />
      <div styleName="option" className="mt3">
        {formatMessage(DIALOG_TITLE.andOr)}
      </div>
      {/*     P H O N E   N U M B E R     */}
      <TextInput
        {...makeProfileField(PHONE_NUMBER)}
        value={phoneNumber}
        onChange={value => onChange({ [PHONE_NUMBER]: value })}
      />
      <FormErrorBlock type={PHONE_NUMBER} errors={validateErrors} />
    </Fragment>
  );
};

EmergencyContactForm.propTypes = {
  email: PropTypes.string,
  formatMessage: PropTypes.func,
  firstName: PropTypes.string,
  phoneNumber: PropTypes.string,
  lastName: PropTypes.string,
  onChange: PropTypes.func,
  relation: PropTypes.string,
  careRole: PropTypes.string,
  validateErrors: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({ description: PropTypes.string }),
  ]),
};

export default CSSModules(EmergencyContactForm, styles, {
  allowMultiple: true,
});



// WEBPACK FOOTER //
// ./src/components/PatientRegistration/PatientEmergencyContact/EmergencyContactForm/index.jsx